let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9mQM4")).then(() => parcelRequire('8UJE5'));